<template>
  <list-template :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <hc-dieuxe-state-header
            :state="advanceSearchForm.state"
            :pageTitle="'Đăng ký điều xe'"
            :stateOptions="stateOptions"
            @doFilter="stateChanged"
          />
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <list-template :classCustom="'list-docs wrapper-content__main'">
        <template #subHeader>
          <sub-header>
            <template #content>
              <div class="leftSection flex-row flex__left">
                <el-button
                  size="medium"
                  type="success"
                  class="createNew"
                  @click="openCreateDialog"
                  v-if="isAbleToCreate"
                >
                  <div class="flex-row flex__center font-weight-bold">
                    <i class="fas fa-plus-circle font-size__large"></i>
                    <span>Tạo yêu cầu</span>
                  </div>
                </el-button>

                <el-button
                  class="btnSolid__blue"
                  size="medium"
                  @click="openReportDialog"
                  v-if="isAbleToApprove"
                >
                  <i class="fas fa-file-export"></i>
                  &nbsp;Xuất báo cáo
                </el-button>
              </div>
              <search
                :keyword="keyword"
                :isDisableAdvanceSearch="true"
                @simpleSearch="simpleSearch"
              >
                <template #quickFilter>
                  <div
                    class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__daterangepicker margin-top-5"
                  >
                    <span class="label-input width__auto"
                      >Thời gian tạo y/c</span
                    >
                    <el-date-picker
                      v-model="createDateRange"
                      type="daterange"
                      format="dd/MM/yyyy"
                      class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                      :picker-options="dateQuickFilterOption"
                      range-separator="_"
                      start-placeholder="_"
                      end-placeholder="_"
                      align="right"
                      :clearable="false"
                      @change="createDateRangeChanged"
                    ></el-date-picker>
                  </div>

                  <!--                  <div-->
                  <!--                    class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large margin-top-5"-->
                  <!--                  >-->
                  <!--                    <span class="label-input width__auto">Trạng thái </span>-->
                  <!--                    <el-select-->
                  <!--                      clearable-->
                  <!--                      class="input-none__border has-border__bottom"-->
                  <!--                      v-model="advanceSearchForm.state"-->
                  <!--                      filterable-->
                  <!--                      placeholder="Trạng thái"-->
                  <!--                      size="medium"-->
                  <!--                      @change="stateChanged"-->
                  <!--                    >-->
                  <!--                      <el-option-->
                  <!--                        v-for="item in stateOptions"-->
                  <!--                        :key="item.id"-->
                  <!--                        :value="item.id"-->
                  <!--                        :label="item.name"-->
                  <!--                      ></el-option>-->
                  <!--                    </el-select>-->
                  <!--                  </div>-->
                </template>
              </search>
            </template>
          </sub-header>
        </template>

        <template #body>
          <template>
            <div class="barChart" ref="barChartContainerDiv">
              <el-table
                v-if="rerenderFlag"
                :data="items"
                class="style-fullWidth"
                highlight-current-row
                :height="chartSize.height"
                sortable="custom"
                @sort-change="doSort"
                @row-click="viewDetail"
              >
                <el-table-column
                  type="index"
                  fixed
                  class="left-table-dieu-xe"
                ></el-table-column>

                <el-table-column property="state" min-width="40" fixed>
                  <template slot-scope="scope">
                    <hc-dieuxe-state-icon :state="scope.row.currentStateCode" />
                  </template>
                </el-table-column>

                <el-table-column
                  property="title"
                  label="Tiêu đề"
                  min-width="100"
                  fixed
                  sortable
                >
                  <template slot-scope="scope">
                    <break-word-span
                      :text="scope.row.title"
                      :maxLength="100"
                    ></break-word-span>
                  </template>
                </el-table-column>

                <el-table-column property="description" label="Nội dung">
                  <template slot-scope="scope">
                    <break-word-span
                      :text="scope.row.description"
                      :maxLength="100"
                    ></break-word-span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Thời gian đi/về"
                  property="startTime"
                  min-width="180"
                  sortable
                >
                  <template slot-scope="scope">
                    <i class="el-icon-time color__blue"></i>
                    Đi:
                    <span>{{
                      scope.row.startTime
                        | dateFormatter({
                          nullValue: "-",
                        })
                    }}</span>
                    <br />
                    <i class="el-icon-time color__red"></i>
                    Về:
                    <span>{{
                      scope.row.endTime
                        | dateFormatter({
                          nullValue: "-",
                        })
                    }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  property="fromPlace"
                  label="Nơi đi"
                  min-width="200"
                >
                  <template slot-scope="scope">
                    <i class="fas fa-map-marker-alt color__blue"></i>
                    Từ:
                    <break-word-span
                      :text="scope.row.fromPlace"
                      :maxLength="100"
                    ></break-word-span>
                    <br />
                    <i class="fas fa-map-marker-alt color__red"></i>
                    Đến:
                    <break-word-span
                      :text="scope.row.toPlace"
                      :maxLength="100"
                    ></break-word-span>
                  </template>
                </el-table-column>

                <el-table-column
                  property="numberOfPeople"
                  label="Số lượng"
                  min-width="100"
                  sortable
                  align="right"
                >
                </el-table-column>

                <el-table-column
                  property="requestUserFullName"
                  label="Người yêu cầu"
                  min-width="300"
                  sortable
                >
                  <template slot-scope="scope">
                    <i class="far fa-user color__blue"></i>
                    <break-word-span
                      :text="`${scope.row.requestUserFullName} (${scope.row.requestUserPositionName} ${scope.row.requestUserDeptName})`"
                      :maxLength="50"
                    ></break-word-span>
                    <br />
                    <i class="fas fa-address-card color__blue"></i>
                    <break-word-span
                      :text="`${scope.row.contactNumber}/${scope.row.requestUserEmail}`"
                      :maxLength="50"
                    ></break-word-span>
                  </template>
                </el-table-column>

                <el-table-column
                  property="requestUserFullName"
                  label="Người phê duyệt"
                  min-width="200"
                  sortable
                >
                  <template slot-scope="scope">
                    <i class="far fa-user color__blue"></i>
                    <break-word-span
                      :text="`${
                        scope.row.approveUserName || 'Chưa có người duyệt'
                      }`"
                      :maxLength="50"
                    ></break-word-span>
                    <br />
                    <!-- <i class="fas fa-address-card color__blue"></i>
                    <break-word-span
                      :text="
                        `${scope.row.contactNumber}/${
                          scope.row.requestUserEmail
                        }`
                      "
                      :maxLength="50"
                    ></break-word-span> -->
                  </template>
                </el-table-column>

                <el-table-column
                  label="Thời gian tạo"
                  property="createTime"
                  min-width="150"
                  sortable
                >
                  <template slot-scope="scope">
                    <i class="el-icon-time color__blue"></i>
                    <span>{{
                      scope.row.createTime
                        | dateFormatter({
                          nullValue: "-",
                        })
                    }}</span>
                  </template>
                </el-table-column>

                <infinite-loading
                  slot="append"
                  @infinite="infiniteHandler"
                  force-use-infinite-wrapper=".el-table__body-wrapper"
                  ref="infiniteLoading"
                >
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
                </infinite-loading>
              </el-table>
            </div>
          </template>
        </template>
      </list-template>

      <hc-dieuxe-create-dialog
        :isOpen="isOpenDialogCreate"
        v-if="isEnableDialogCreate"
        @dialogClosed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
        @insertSuccess="createDialogSuccess"
      />

      <hc-dieuxe-report-dialog
        :isOpen="isOpenDialogReport"
        v-if="isEnableDialogReport"
        @dialogClosed="isEnableDialogReport = false"
        @closeDialog="isOpenDialogReport = false"
        @insertSuccess="createDialogSuccess"
      />
    </template>
  </list-template>
</template>

<script>
import headerTemplate from "../../../components/header/main-header.vue";
import listTemplate from "../../common/list";
import hanhchinhService from "../../../services/hanhchinhService";
import utils from "../../../services/utils";
import h from "../../../services/h";
import Search from "../../common/search";
import SubHeader from "../../../components/main/sub-header";
import dateUtils from "../../../dateUtils";
import constants from "../../../constants";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcCaseDieuXeViewService from "../../../services/hcCaseDieuXeViewService";
import HcDieuxeCreateDialog from "./hc-dieuxe-create-dialog";
import HcDieuxeStateIcon from "./hc-dieuxe-state-icon";
import BreakWordSpan from "../ketluan/break-word-span";
import dateFormatter from "../../../filters/dateFormatter";
import goBackMixin from "../../../mixins/goBackMixin";
import HcDieuxeStateHeader from "./hc-dieuxe-state-header";
import hcFlowService from "../../../services/hcFlowService";
import HcDieuxeReportDialog from "./hc-dieuxe-report-dialog";

export default {
  mixins: [goBackMixin],

  components: {
    HcDieuxeCreateDialog,
    HcDieuxeReportDialog,
    HcDieuxeStateHeader,
    BreakWordSpan,
    HcDieuxeStateIcon,
    SubHeader,
    Search,
    headerTemplate,
    listTemplate,
    filterByStatus: () => import("../components/filter-by-status-header.vue"),
  },

  filters: { dateFormatter },

  data() {
    return {
      keyword: null,
      advanceSearchForm: {
        keyword: null,
        fromCreateDate: null,
        toCreateDate: null,
        state: null,
      },
      createDateRange: null,
      dateQuickFilterOption: null,
      stateOptions: null,
      dieuXeHcFlows: null,
      dieuXeHcFlowsWhichCanApprove: null,

      items: [],
      page: 0,
      size: 10,
      sort: "updateTime",
      order: "desc",
      chartSize: {
        width: 100,
        height: 100,
      },
      rerenderFlag: false,
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      isOpenDialogReport: false,
      isEnableDialogReport: false,
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    isAbleToCreate() {
      return this.dieuXeHcFlows && this.dieuXeHcFlows.length;
    },

    isAbleToApprove() {
      return (
        this.dieuXeHcFlowsWhichCanApprove &&
        this.dieuXeHcFlowsWhichCanApprove.length
      );
    },
  },

  watch: {
    isOpenDialogCreate(newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },

    isOpenDialogReport(newValue) {
      newValue && (this.isEnableDialogReport = newValue);
    },
  },

  created() {
    this.initDateQuickFilterOption();
    this.initStateOptions();
    this.initQuery();
    this.registerEventBusForMaster((event) => {
      this.doSearch();
    });
    this.loadHcFlowsWhichUserCanStart();
    this.loadHcFlowWhichUserCanApprove();
  },

  destroyed() {
    this.unregisterEventBusForMaster();
  },

  mounted() {
    this.calculateChartSize();
    this.rerenderFlag = true;
  },

  methods: {
    openReportDialog() {
      this.isOpenDialogReport = true;
    },

    loadHcFlowsWhichUserCanStart() {
      return hcFlowService
        .findAllDieuXeHcFlowWhichUserCanStart()
        .then((response) => (this.dieuXeHcFlows = response.data));
    },

    loadHcFlowWhichUserCanApprove() {
      return hcFlowService
        .findAllDieuXeHcFlowWhichUserCanApprove()
        .then(
          (response) => (this.dieuXeHcFlowsWhichCanApprove = response.data)
        );
    },

    openCreateDialog() {
      this.isOpenDialogCreate = true;
    },

    doSort(event) {
      this.sort = event.prop;
      switch (event.order) {
        case "ascending":
          this.order = "asc";
          break;
        case "descending":
          this.order = "desc";
          break;
        default:
          this.order = null;
      }
      this.doSearch();
    },

    reloadPage() {
      this.doSearch();
    },

    convertToSearchForm() {
      return {
        keyword: this.advanceSearchForm.keyword,
        fromCreateDate: this.advanceSearchForm.fromCreateDate,
        toCreateDate: this.advanceSearchForm.toCreateDate,
        state:
          this.advanceSearchForm.state === "-1"
            ? null
            : this.advanceSearchForm.state ===
                constants.HC_STATE.STATE_CODE.DIEU_XE.DA_DANG_KY ||
              this.advanceSearchForm.state ===
                constants.HC_STATE.STATE_CODE.DIEU_XE.CHO_PHE_DUYET
            ? constants.HC_STATE.STATE_CODE.DIEU_XE.CHO_PHE_DUYET
            : this.advanceSearchForm.state,
      };
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(","),
      };
      return hcCaseDieuXeViewService
        .findAll(this.convertToSearchForm(), pageable)
        .then((response) => {
          let items = response.data || [];
          if (
            this.advanceSearchForm.state ===
            constants.HC_STATE.STATE_CODE.DIEU_XE.DA_DANG_KY
          ) {
            items = items.filter(
              (item) => item.requestUserId === this.$store.getters.user.id
            );
          }
          items && this.items.push(...items);
          return items;
        });
    },

    infiniteHandler($state) {
      this.list().then((items) => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    doSearch() {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: this.buildQuery(),
      });
      this.items = [];
      this.page = 0;
      this.$nextTick(() => {
        this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset();
      });
    },

    buildQuery() {
      return utils.merge(
        { sort: this.sort, order: this.order },
        this.advanceSearchForm
      );
    },

    calculateChartSize() {
      this.chartSize.width = this.$refs.barChartContainerDiv.clientWidth;
      this.chartSize.height = this.$refs.barChartContainerDiv.clientHeight;
    },

    initStateOptions() {
      this.stateOptions = h.collect(
        [
          "-1",
          this.userDeptRole && this.userDeptRole.roleCode &&
          this.userDeptRole.roleCode !== constants.ROLE.CODE.DIEU_XE.QUAN_LY_XE
            ? constants.HC_STATE.STATE_CODE.DIEU_XE.DA_DANG_KY
            : constants.HC_STATE.STATE_CODE.DIEU_XE.CHO_PHE_DUYET,
          constants.HC_STATE.STATE_CODE.DIEU_XE.DA_PHE_DUYET,
          // constants.HC_STATE.STATE_CODE.DIEU_XE.TU_CHOI,
          constants.HC_STATE.STATE_CODE.DIEU_XE.HUY,
        ],
        (state) => {
          return {
            id: state,
            name:
              state === "-1"
                ? "Tất cả"
                : hanhChinhUtils.getDieuXeStateLabel(state),
          };
        }
      );
    },

    stateChanged(event) {
      this.advanceSearchForm.state = event.state;
      this.doSearch();
    },

    createDateRangeChanged() {
      utils.timeRangeChanged(this.createDateRange, (from_, to_) => {
        this.advanceSearchForm.fromCreateDate = from_;
        this.advanceSearchForm.toCreateDate = to_;
      });
      this.doSearch();
    },

    simpleSearch(event) {
      this.advanceSearchForm.keyword = this.keyword = event;
      this.doSearch();
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          ),
        ],
      };
    },

    initQuery() {
      let query = this.$route.query;
      this.advanceSearchForm.keyword = utils.getParamFromQuery(
        query,
        "keyword"
      );
      this.advanceSearchForm.state =
        utils.getParamFromQuery(query, "state") || "-1";
      this.advanceSearchForm.fromCreateDate = utils.getIntParamsFromQuery(
        query,
        "fromCreateDate"
      );
      this.advanceSearchForm.toCreateDate = utils.getIntParamsFromQuery(
        query,
        "toCreateDate"
      );

      this.keyword = this.advanceSearchForm.keyword;
      this.initCreateDateRange();
    },

    initCreateDateRange() {
      this.createDateRange = utils.initTimeRange(
        this.advanceSearchForm.fromCreateDate,
        this.advanceSearchForm.toCreateDate
      );

      if (!this.createDateRange) {
        utils.timeRangeChanged(
          (this.createDateRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
          )),
          (from_, to_) => {
            this.advanceSearchForm.fromCreateDate = from_;
            this.advanceSearchForm.toCreateDate = to_;
          }
        );
      }
    },

    viewDetail(row, column, event) {
      let caseMasterId = row.hcCaseMasterId;
      let params = utils.merge(this.$route.params, { id: caseMasterId });
      this.$router.push({
        name: "adminstration-getCarDetail",
        params: params,
        query: this.$route.query,
      });
    },

    // viewCalendar() {
    //   let params = utils.merge(this.$route.params);
    //   this.$router.push({
    //     name: "adminstration-getCarCalendar",
    //     params: params,
    //     query: null
    //   });
    // },

    closeDialog() {
      this.isOpenDialogCreate = false;
    },

    createDialogSuccess() {
      this.isOpenDialogCreate = false;
      this.reloadPage();
    },

    getProcedureInformation() {
      return hanhchinhService
        .getProcedureInformation(this.flowCode)
        .then((response) => {
          if (response.data.hcFlow !== null) {
            this.hcFlow = response.data.hcFlow;
            this.flowId = this.hcFlow.id;
            this.processing = false;
          }
        });
    },

    getProcessingCar(page) {
      let pageable = {
        page: page,
        size: this.size,
        sort: [this.sortProcessing, this.order].join(","),
      };

      return hanhchinhService
        .getProcessing(
          this.flowCode,
          this.startTime,
          this.endTime,
          this.searchKey,
          pageable
        )
        .then((response) => {
          let items = response.data.data;
          this.processingCars.push(...items);
        });
    },

    getProcessedCar(page) {
      let pageable = {
        page: page,
        size: this.size,
        sort: [this.sortProcessed, this.order].join(","),
      };

      return hanhchinhService
        .getProcessed(
          this.flowCode,
          this.startTime,
          this.endTime,
          this.searchKey,
          pageable
        )
        .then((response) => {
          let items = response.data.data;
          this.processedCars.push(...items);
        });
    },

    toProcessing() {
      this.processing = true;
    },

    toProcessed() {
      this.processing = false;
    },

    sortByCreateTime(e) {
      this.order = e.sortOrder;
      this.sortProcessed = e.sortBy;
      this.sortProcessing = e.sortBy;
      this.reloadPage();
    },

    sortByUpdateTime(e) {
      this.order = e.sortOrder;
      this.sortProcessed = e.sortBy;
      this.sortProcessing = e.sortBy;
      this.reloadPage();
    },

    search(keyword) {
      this.searchKey = keyword;
      this.reloadPage();
    },
  },
};
</script>

<style scoped>
.filterBtngroup {
  display: flex;
}

.filterBtn {
  padding: 10px 30px;
  box-shadow: 0 4px 3px -3px #dcdcdc;
}

.filterBtn:hover {
  background-color: #025cab;
  color: #fff;
}

.filterBtn:focus {
  background-color: #025cab;
  color: #fff;
}

.actived {
  background-color: #025cab;
  color: #fff;
}

.myFooter {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  bottom: 0;
  right: 24px;
  left: 24px;
  min-height: 60px;
  border-radius: 2px;
  /* width: 100%; */
  background: #f4f4f4;
}

.fix-width__daterangepicker {
  flex: auto 0 0;
  width: 330px;
}

.barChart {
  margin-top: 20px;
  height: calc(100% - 135px) !important;
  width: calc(100% - 20px) !important;
  position: relative;
}

.color__bronze {
  color: darkorange;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/dieuXe_Index.vue